<template>
  <v-toolbar flat color="transparent">
    <!-- <v-app-bar-nav-icon small v-if="showBackButton" @click="$router.go(-1)">
      <v-icon>mdi-chevron-left</v-icon>
    </v-app-bar-nav-icon> -->
    <v-toolbar-title class="font-weight-regular">
      <div v-if="!showBackButton">{{ title }}</div>
      <div v-else><v-chip color="transparent" @click="$router.go(-1)"> <v-icon>mdi-chevron-left</v-icon>{{ title }}</v-chip></div>
    </v-toolbar-title>
    <v-spacer> </v-spacer>
    <slot></slot>
    <v-btn :fab="$vuetify.breakpoint.xsOnly" :small="$vuetify.breakpoint.xsOnly"  v-if="access" @click="$emit('add')" color="primary">
      <v-icon dark v-if="$vuetify.breakpoint.xsOnly">mdi-plus </v-icon>
      <span v-if="!$vuetify.breakpoint.xsOnly">{{ buttonTitle }}</span>
    </v-btn>
  </v-toolbar>
</template>
<script>
export default {
  name: "list-title-bar",
  props: {
    buttonTitle: {
      default: "Add",
    },
    title: {
      default: "Title",
    },
    color: {
      default: "grey lighten-3",
    },
    access: {
      default: true,
    },
    showBackButton: {
      default: true,
    },
  },
};
</script>

